<div class="content-container">
  <div class="med-info">
    <p><b>Medication:</b> {{ order.medName }}</p>
    <p><b>Route:</b> {{ order.route }}</p>
    @if (order.isSlidingScale || order.isMealTimes) {
    @if (order.isSlidingScale) {
    <p-table [value]="order.slidingScaleTable" class="table">
      <ng-template pTemplate="caption">
        Sliding Scale
      </ng-template>
      <ng-template #header>
        <tr>
          <th class="table-column">BS</th>
          <th class="table-column">Units</th>
        </tr>
      </ng-template>
      <ng-template #body let-entry>
        <tr>
          <td class="table-column"> {{ entry.bs }} </td>
          <td class="table-column"> {{ entry.units }} </td>
        </tr>
      </ng-template>
    </p-table>
    }
    @if (order.isMealTimes) {
    <p-table [value]="order.mealTimesTable" class="table">
      <ng-template pTemplate="caption">
        Meal Time Coverage
      </ng-template>
      <ng-template #header>
        <tr>
          <th class="table-column">Carbs</th>
          <th class="table-column">Units</th>
        </tr>
      </ng-template>
      <ng-template #body let-entry>
        <tr>
          <td class="table-column"> {{ entry.carbs }} </td>
          <td class="table-column"> {{ entry.units }} </td>
        </tr>
      </ng-template>
    </p-table>
    }
    <emr-input type="text" label="Dose" width='30%' [control]="doseGivenFormControl" [bottomSpace]="true"></emr-input>
    <emr-input type="text" label="Blood Sugar" width='30%' [control]="bloodSugarFormControl"
      [bottomSpace]="true"></emr-input>
    } @else {
    <p><b>Dosage:</b> {{ order.dosage }}</p>
    }
    @if (order.isPRN) {
    <p> <b>Last given at: </b> {{ order.prnLastGivenTimeString }}
    <p> <b>Dosing Instructions: </b>{{ order.prnDosingInstructions }} </p>
    }

    <p><b>Notes:</b> {{ order.orderNotes }}</p>
  </div>

  <div class="administer-container">
    <div class="administer-content">
      <emr-input type="text" label="Medication ID" [control]="medicationIdFormControl" [bottomSpace]="true"
        autofocus></emr-input>
      <button pButton pRipple type="button" label="Administer" class="p-button-outlined" color="primary"
        (click)="onSubmit()"></button>
    </div>
  </div>

  @if (! order.isPRN) {
  <p>
    <span [ngStyle]="{ color: isOverdosed ? 'red' : 'black' }">{{ order.quantityGiven }}</span>
    out of {{ order.quantity }} administered.
  </p>
  }
</div>

<div class="error-container">
  @if (submitted) {
    <p class="error-msg">{{ error }}</p>
  }
</div>

<div class="dialog-actions">
  <button pButton pRipple (click)="onCloseClick()">Close</button>
</div>